import PropTypes from 'prop-types'

const navigationItemClass = `tw-duration-100 
  tw-py-1
  tw-inline-block
  tw-ease-linear
  tw-border-transparent
  tw-border-0 
  tw-border-b
  tw-border-solid
  tw-no-underline
  hover:tw-no-underline
  hover:tw-text-header-active
  focus:tw-no-underline
  focus:tw-text-header-active`

export default function NavigationLink({
  active,
  children,
  href,
  inToolbar,
  ...props
}) {
  return (
    <a
      className={`
      ${
        active
          ? 'tw-text-header-active md:tw-border-header-active-border'
          : 'tw-text-header-primary'
      } 
      ${navigationItemClass}
      ${
        inToolbar
          ? ''
          : 'md:hover:tw-border-header-border md:focus:tw-border-header-border'
      }`}
      href={href}
      {...props}>
      {children}
    </a>
  )
}

export function NavigationButton({
  active,
  children,
  onClick,
  inToolbar,
  ...props
}) {
  return (
    <button
      onClick={onClick}
      className={`${
        active
          ? 'tw-text-header-primary md:tw-border-header-active-border'
          : 'tw-text-header-primary'
      } 
      tw-custom-button-reset
      tw-relative
      tw-z-10 
      tw-uppercase 
      tw-w-full
      tw-text-left
      ${navigationItemClass}
      ${
        inToolbar
          ? ''
          : 'md:hover:tw-border-header-border md:focus:tw-border-header-border'
      }`}
      {...props}>
      {children}
    </button>
  )
}

NavigationButton.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  inToolbar: PropTypes.bool,
}

NavigationLink.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  href: PropTypes.string,
  inToolbar: PropTypes.bool,
}
